import appStoreBadge from "./app-store-badge.svg?url"

export default {
  src: appStoreBadge,
  width: 156,
  height: 52,
}